import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { UPDATE_TEMPLATE, UPDATE_TEMPLATE_SUCCESS, UPDATE_TEMPLATE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updateTemplate({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/templates/${payload?.params}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Template updated successfully!`);
      yield put({
        type: UPDATE_TEMPLATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_TEMPLATE_ERROR,
        payload: response?.response?.data,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_TEMPLATE_ERROR, payload: error });
  }
}

export function* watchUpdateTemplate() {
  yield takeEvery(UPDATE_TEMPLATE, updateTemplate);
}

function* updateTemplateSaga() {
  yield all([fork(watchUpdateTemplate)]);
}

export default updateTemplateSaga;
